// ContactStep.tsx — widget del step 'contact' (datos de contacto para los
// AI-styled posters que muestran info de contacto).
// Qué hace: form de address/phone/whatsapp/hours/email + guardar o saltar.
// Qué exporta: ContactStep.
// Quién lo usa: NovahGenerateChat.

import { type Dispatch, type SetStateAction } from 'react';
import { ContactDraft } from '../types';
import { WidgetWrap, ContactForm, ContactInput, ConfirmBtn, SkipBtn } from '../styled';

interface Props {
  contactDraft: ContactDraft;
  setContactDraft: Dispatch<SetStateAction<ContactDraft>>;
  savingContact: boolean;
  saveContactAndContinue: () => void;
  skipContact: () => void;
}

export function ContactStep({ contactDraft, setContactDraft, savingContact, saveContactAndContinue, skipContact }: Props) {
  return (
    <WidgetWrap>
      <ContactForm>
        <ContactInput placeholder="Address" value={contactDraft.address}
          onChange={(e) => setContactDraft((c) => ({ ...c, address: e.target.value }))} />
        <ContactInput placeholder="Phone" value={contactDraft.phoneNumber}
          onChange={(e) => setContactDraft((c) => ({ ...c, phoneNumber: e.target.value }))} />
        <ContactInput placeholder="WhatsApp" value={contactDraft.whatsapp}
          onChange={(e) => setContactDraft((c) => ({ ...c, whatsapp: e.target.value }))} />
        <ContactInput placeholder="Business hours (e.g. Mon-Fri 9-18)" value={contactDraft.businessHours}
          onChange={(e) => setContactDraft((c) => ({ ...c, businessHours: e.target.value }))} />
        <ContactInput placeholder="Email" value={contactDraft.email}
          onChange={(e) => setContactDraft((c) => ({ ...c, email: e.target.value }))} />
      </ContactForm>
      <ConfirmBtn onClick={saveContactAndContinue} disabled={savingContact} style={{ marginTop: 4 }}>
        {savingContact ? 'Saving…' : 'Save & continue'}
      </ConfirmBtn>
      <SkipBtn onClick={skipContact}>Skip — omit contact info</SkipBtn>
    </WidgetWrap>
  );
}
